'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upload = exports.getThumbnail = exports.getPreview = exports.download = undefined;

var _httpClient = require('http-client');

var bearerToken = function bearerToken(token) {
  return (0, _httpClient.auth)('Bearer ' + token);
};

var apiVersion = function apiVersion(version) {
  return (0, _httpClient.base)('https://content.dropboxapi.com/' + version);
};

var apiArgs = function apiArgs(args) {
  return (0, _httpClient.header)('Dropbox-API-Arg', JSON.stringify(args));
};

var apiResult = function apiResult() {
  var propertyName = arguments.length <= 0 || arguments[0] === undefined ? 'apiResult' : arguments[0];
  return (0, _httpClient.handleResponse)(function (response) {
    var result = response.headers.get('Dropbox-API-Result');

    if (result) response[propertyName] = JSON.parse(result);

    return response;
  });
};

var returnFile = (0, _httpClient.createStack)(apiResult(), (0, _httpClient.handleResponse)(function (response) {
  return {
    metadata: response.apiResult,
    content: response.body
  };
}));

var getFile = function getFile(token, path, args) {
  return (0, _httpClient.createFetch)((0, _httpClient.method)('POST'), bearerToken(token), apiVersion(2), apiArgs(args), returnFile)(path);
};

var putFile = function putFile(token, content, contentType, path, args) {
  return (0, _httpClient.createFetch)((0, _httpClient.method)('POST'), bearerToken(token), apiVersion(2), apiArgs(args), (0, _httpClient.body)(content, contentType))(path);
};

var download = exports.download = function download(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return getFile(token, '/files/download', params);
};

var getPreview = exports.getPreview = function getPreview(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return getFile(token, '/files/get_preview', params);
};

var getThumbnail = exports.getThumbnail = function getThumbnail(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return getFile(token, '/files/get_thumbnail', params);
};

var upload = exports.upload = function upload(token, content) {
  var contentType = arguments.length <= 2 || arguments[2] === undefined ? 'application/octet-stream' : arguments[2];
  var params = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
  return putFile(token, content, contentType, '/files/upload', params);
};


//////////////////
// WEBPACK FOOTER
// ./~/dropbox-client/lib/DropboxContent.js
// module id = 100
// module chunks = 0